"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnicodeCharacterDecoder = void 0;
var tslib_1 = require("tslib");
var unicode_char_helper_1 = require("../../utils/unicode-char-helper");
var character_decoder_1 = require("./character-decoder");
var UnicodeCharacterDecoder = (function (_super) {
    tslib_1.__extends(UnicodeCharacterDecoder, _super);
    function UnicodeCharacterDecoder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._chars = [];
        return _this;
    }
    UnicodeCharacterDecoder.prototype.processChar = function (importer, ch) {
        if (this._chars.length >= UnicodeCharacterDecoder.capacity)
            this.flush(importer);
        this._chars.push(ch);
    };
    UnicodeCharacterDecoder.prototype.flush = function (importer) {
        if (this._chars.length > 0) {
            if (!this.canAppendText(importer) || this._chars.length <= 1)
                this.flushByChar(importer, this._chars);
            else {
                var str = this._chars.join('').normalize();
                this.flushByString(importer, str);
            }
            this._chars = [];
        }
    };
    UnicodeCharacterDecoder.prototype.canAppendText = function (importer) {
        return importer.destination.canAppendText;
    };
    UnicodeCharacterDecoder.prototype.flushByChar = function (importer, chars) {
        var normalizedChars = [];
        for (var index = 0; index < chars.length; index++) {
            var high = chars[index];
            var low = chars[index + 1];
            if (low && unicode_char_helper_1.UnicodeCharHelper.isLowSurrogate(low)) {
                if (unicode_char_helper_1.UnicodeCharHelper.isHighSurrogate(high))
                    normalizedChars.push(high + low);
                else
                    normalizedChars.push(high, low);
                index++;
            }
            else
                normalizedChars.push(high);
        }
        for (var _i = 0, normalizedChars_1 = normalizedChars; _i < normalizedChars_1.length; _i++) {
            var ch = normalizedChars_1[_i];
            importer.processChar(ch);
        }
    };
    UnicodeCharacterDecoder.prototype.flushByString = function (importer, str) {
        importer.destination.processText(str);
    };
    UnicodeCharacterDecoder.capacity = 1024;
    return UnicodeCharacterDecoder;
}(character_decoder_1.CharacterDecoder));
exports.UnicodeCharacterDecoder = UnicodeCharacterDecoder;
